var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 17,
    viewBox: "0 0 21 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84553 16.0958H17.9797C18.2306 16.0958 18.4396 15.8867 18.4396 15.6359V14.5071H2.38565V15.6359C2.38565 15.9285 2.59469 16.0958 2.84553 16.0958ZM19.1921 2.71746C18.4814 2.71746 17.9379 3.26096 17.9379 3.97168C17.9379 4.30614 18.0633 4.64059 18.3142 4.84963L14.5515 8.69589L10.9979 2.3412C11.3742 2.13216 11.625 1.71409 11.625 1.25421C11.625 0.543493 11.0815 0 10.3708 0C9.66009 0 9.1166 0.543493 9.1166 1.25421C9.1166 1.71409 9.36744 2.13216 9.74371 2.3412L6.1901 8.69589L2.42746 4.84963C2.76191 4.64059 2.88734 4.30614 2.88734 3.97168C2.88734 3.26096 2.34384 2.71746 1.63312 2.71746C0.922399 2.71746 0.378906 3.26096 0.378906 3.97168C0.378906 4.6824 0.922399 5.22589 1.63312 5.22589C1.67493 5.22589 1.71673 5.22589 1.71673 5.22589L2.38565 13.7546H18.4396L19.1085 5.22589C19.1503 5.22589 19.1921 5.22589 19.1921 5.22589C19.9028 5.22589 20.4463 4.6824 20.4463 3.97168C20.4463 3.30276 19.9028 2.71746 19.1921 2.71746Z",
    fill: "#D9D9D9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.27962dd3ec142f0c5eac4196c053a2ad.svg";
export { ForwardRef as ReactComponent };